var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',_vm._l((_vm.newItemData.images),function(image){return _c('v-col',{key:image.id,attrs:{"cols":"12","sm":"6","md":"6"}},[_c('image-item',{attrs:{"image":image},on:{"removed":_vm.removeImage}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }